module.exports = __webpack_public_path__ + "static/img/business.733ebf1c.png";